// AUTO-GENERATED - DO NOT EDIT MANUALLY

import {
  AcceptRematchDto,
  DeclineRematchDto,
  LobbyResponseDto,
  LobbyStatisticDto,
  RematchRequestResponseDto,
  RequestRematchDto,
  ResolveRouteResponseDto,
  IBaseArrayResultDto,
  IBaseSingleResultDto,
} from '@skillarea/lib-shared';

import { IRequestOptions, IRequestConfig, getConfigs, axios } from './options';

export const basePath = '';

export class MatchmakingService {
  /**
   * GET /api/matchmaking/lobby/active
   */
  getActiveLobby(
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<LobbyResponseDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/matchmaking/lobby/active';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options,
      );

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * GET /api/matchmaking/lobbies/active
   */
  getActiveLobbies(
    options: IRequestOptions = {},
  ): Promise<IBaseArrayResultDto<LobbyResponseDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/matchmaking/lobbies/active';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options,
      );

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * GET /api/matchmaking/stats
   */
  getStats(
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<LobbyStatisticDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/matchmaking/stats';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options,
      );

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * GET /api/matchmaking/resolve-route
   */
  resolveRoute(
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<ResolveRouteResponseDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/matchmaking/resolve-route';

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options,
      );

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * POST /api/matchmaking/rematch/request
   */
  requestRematch(
    params: {
      /** requestBody */
      body?: RequestRematchDto;
    },
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<RematchRequestResponseDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/matchmaking/rematch/request';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options,
      );

      let data = params.body;
      configs.data = data;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * POST /api/matchmaking/rematch/accept
   */
  acceptRematch(
    params: {
      /** requestBody */
      body?: AcceptRematchDto;
    },
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<RematchRequestResponseDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/matchmaking/rematch/accept';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options,
      );

      let data = params.body;
      configs.data = data;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * POST /api/matchmaking/rematch/decline
   */
  declineRematch(
    params: {
      /** requestBody */
      body?: DeclineRematchDto;
    },
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<RematchRequestResponseDto>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/matchmaking/rematch/decline';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options,
      );

      let data = params.body;
      configs.data = data;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }
}
